import styled from 'styled-components'
import { Colors } from 'styles'

export const Container = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 24px;
`

export const Title = styled.h1`
  margin: 0;
  font-family: SpaceGrotesk;
  font-size: 1.6em;
  text-align: center;
  text-wrap: balance;
`

export const PodcastContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  gap: 24px;
  width: 100%;
`

export const PodcastImage = styled.img`
  box-sizing: border-box;
  width: 100%;
  border-radius: 12px;
  max-width: 132px;
  height: fit-content;
`

export const PodcastInfoContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 8px;
`

export const PodcastTitle = styled.h1`
  margin: 0;
  font-family: 'Inter';
  font-size: 1.2em;
`

export const PodcastDescription = styled.p`
  font-family: 'Inter';
  font-size: 0.8em;
  max-height: 100px;
  margin: 0;
  color: ${Colors.GREY[400]};
`

export const ActionsContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  gap: 24px;
  justify-content: flex-end;
  width: 100%;
`
